export default __webpack_public_path__ + "assets/sao-marcos-component.0f5a539e.svg";